import { shape, string } from 'prop-types';
import React from 'react';
import { components } from 'react-select';

const MultiValueContainer = props => {
    const { data } = props;
    return <components.MultiValue {...props}>{data.label}</components.MultiValue>;
};

MultiValueContainer.propTypes = {
    data: shape({
        label: string.isRequired,
    }).isRequired,
};

export default MultiValueContainer;
